import Dexie from 'dexie';

export interface StoredItem {
  isReady: boolean;
  holData: any[];
}

export class AppDB extends Dexie {
  items!: Dexie.Table<StoredItem, number>;

  constructor() {
    super('AppDB');
    this.version(1).stores({
      items: '++id'
    });
  }
}

export const db = new AppDB();